module.exports = __webpack_public_path__ + "static/media/bg-image-51.eb766953.jpg";